<template>
  <div>
    <div class="swiper-container w-full" ref="swiperContainer">
      <div class="swiper-wrapper items-end">
        <slot />
      </div>
    </div>
    <swiper-navigation-component
      v-if="showNavigation"
    ></swiper-navigation-component>
  </div>
</template>

<script lang="ts">
import {
  HashNavigation,
  Keyboard,
  Swiper,
  SwiperModule,
} from 'swiper/js/swiper.esm';
import { Ref, computed, defineComponent, onMounted, ref } from 'vue';
import swiper from '../utils/swiper';
import SwiperNavigationComponent from './SwiperNavigationComponent.vue';

export default defineComponent({
  components: {
    SwiperNavigationComponent,
  },

  props: {
    hashNavigation: { type: Boolean, default: false },
    autoHeight: { type: Boolean, default: false },
  },

  setup(props) {
    const swiperContainer: Ref<HTMLElement | undefined> = ref();
    const modules: SwiperModule[] = [Keyboard];

    const showNavigation = computed(() => {
      if (swiper.value) {
        return swiper.value.slides.length > 1;
      }
      return false;
    });

    if (props.hashNavigation) {
      modules.push(HashNavigation);
    }
    Swiper.use(modules);

    onMounted(() => {
      if (swiperContainer.value) {
        swiper.value = new Swiper(swiperContainer.value, {
          spaceBetween: 36,
          init: false,
          autoHeight: props.autoHeight,
          hashNavigation: { watchState: props.hashNavigation },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          on: {
            hashSet() {
              const hash = document.location.hash.substr(1);
              const objectTeasers = Array.from(
                document.querySelectorAll('[data-id]')
              );

              objectTeasers
                .map((teaser) => {
                  teaser.classList.remove('current');
                  return teaser;
                })
                .filter((teaser) => (teaser as HTMLElement).dataset.id === hash)
                .map((teaser) => teaser.classList.add('current'));
            },
          },
        });
        setTimeout(() => {
          if (swiper.value) {
            (swiper.value as any).init();
          }
        }, 100);
      }
    });

    return { swiperContainer, showNavigation };
  },
});
</script>

<style src="swiper/css/swiper.css"></style>
